import { Toast, Card, Loader, Menu, SubmitBar, ActionBar, CheckBox } from "@egovernments/digit-ui-react-components";
import React, { Fragment, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import BPAApplicationTimeline from "./BPAApplicationTimeline";
import ActionModal from "./Modal";
import { getBPAFormData, convertDateToEpoch, printPdf, downloadPdf } from "../../../utils";
import cloneDeep from "lodash/cloneDeep";
import { OBPSService } from "../../../../../../libraries/src/services/elements/OBPS";
import ApplicationView12 from "../../../../../templates/Forms/Form12/Application12View";
import { Tab, Tabs } from "@mui/material";
import TabPanel from "../../../pageComponents/TabPanel";
import axios from "axios";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button } from "react-bootstrap";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

const tablist = [
  { label: "WF_TAKE_ACTION", color: "red" },
  { label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS", color: "red" },
];

const BpaApplicationDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateCode = Digit.ULBService.getStateId();
  const queryClient = useQueryClient();
  const [showToast, setShowToast] = useState(null);
  const [isTocAccepted, setIsTocAccepted] = useState(false);
  const [displayMenu, setDisplayMenu] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const [checkBoxVisible, setCheckBoxVisible] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [showTakeAction, setShowTakeAction] = useState("");
  // Tab
  const [currentTab, setCurrentTab] = useState("0");
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };
  sessionStorage.removeItem("BPA_SUBMIT_APP");
  sessionStorage.setItem("isEDCRDisable", JSON.stringify(true));
  sessionStorage.setItem("BPA_IS_ALREADY_WENT_OFF_DETAILS", JSON.stringify(false));

  const history = useHistory();
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const userInfo = Digit.UserService.getUser()?.info || {};
  sessionStorage.setItem("bpaApplicationDetails", false);
  let isFromSendBack = false;
  const { data: stakeHolderDetails, isLoading: stakeHolderDetailsLoading } = Digit.Hooks.obps.useMDMS(
    stateCode,
    "StakeholderRegistraition",
    "TradeTypetoRoleMapping"
  );
  const { isLoading: bpaDocsLoading, data: bpaDocs } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["DocTypeMapping"]);
  const { data, isLoading } = id && Digit.Hooks.obps.useBPADetailsPage(tenantId, { applicationNo: id });
  console.log("7777", id, data);
  const { isMdmsLoading, data: mdmsData } = Digit.Hooks.obps.useMDMS(tenantId.split(".")[0], "BPA", ["RiskTypeComputation"]);
  const mutation = Digit.Hooks.obps.useObpsAPI(data?.applicationData?.tenantId, false);

  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: data?.applicationData?.tenantId,
    id: id,
    moduleCode: "OBPS",
    config: {
      enabled: !!data,
    },
  });
  console.log("7777ww", mutation, workflowDetails?.data?.nextActions?.[0]?.action);
  const textForNews = "Please upload the Site Inspection Report within 15 days after approval.";
  const signValidity = "Please updload signature in profile section to get Structural Stability Certificate.";
  const signforApprovalLetter = "Please updload signature in profile section to get Approval Letter.";
  const userSearch = Digit.UserService.getUser()?.info;
  const isStakeholder = userSearch?.roles?.length > 1;
  const signValid = userSearch?.signature;

  let businessService = [];
  const plotArea = data?.applicationData?.plotArea > 500 ? "MAXPLOT" : "MINPLOT";
  if (data && data?.applicationData?.businessService === "BPA_LOW") {
    businessService = ["BPA.LOW_RISK_PERMIT_FEE"];
  } else if (data && data?.applicationData?.businessService === "BPA" && data?.applicationData?.riskType === "HIGH") {
    businessService = ["BPA.NC_APP_FEE", "BPA.NC_SAN_FEE"];
  } else {
    businessService = ["BPA.NC_OC_APP_FEE", "BPA.NC_OC_SAN_FEE"];
  }

  // useEffect(() => {
  //   if(!bpaDocsLoading && !isLoading){
  //     let filtredBpaDocs = [];
  //     if (bpaDocs?.BPA?.DocTypeMapping) {
  //       filtredBpaDocs = bpaDocs?.BPA?.DocTypeMapping?.filter(ob => (ob.WFState == "INPROGRESS" && ob.RiskType == data?.applicationData?.riskType && ob.ServiceType == data?.applicationData?.additionalDetails?.serviceType && ob.applicationType == data?.applicationData?.additionalDetails?.applicationType))
  //       let documents = data?.applicationDetails?.filter((ob) => ob.title === "BPA_DOCUMENT_DETAILS_LABEL")[0]?.additionalDetails?.obpsDocuments?.[0]?.values;
  //       // let RealignedDocument = [];
  //       // filtredBpaDocs && filtredBpaDocs?.[0]?.docTypes && filtredBpaDocs?.[0]?.docTypes.map((ob) => {
  //       //     documents && documents.filter(x => ob.code === x.documentType.slice(0,x.documentType.lastIndexOf("."))).map((doc) => {
  //       //         RealignedDocument.push(doc);
  //       //     })
  //       // })
  //       // const newApplicationDetails = data?.applicationDetails.map((obj) => {
  //       //   if(obj.title === "BPA_DOCUMENT_DETAILS_LABEL")
  //       //   {
  //       //     return {...obj, additionalDetails:{obpsDocuments:[{title:"",values:RealignedDocument}]}}
  //       //   }
  //       //   return obj;
  //       // })
  //       // data.applicationDetails = [...newApplicationDetails];
  //   }
  //   }
  // },[bpaDocs,data])

  useEffect(() => {
    if (data?.applicationData?.status == "CITIZEN_APPROVAL_INPROCESS" || data?.applicationData?.status == "INPROGRESS") setCheckBoxVisible(true);
    else setCheckBoxVisible(false);
  }, [data]);

  const getTranslatedValues = (dataValue, isNotTranslated) => {
    if (dataValue) {
      return !isNotTranslated ? t(dataValue) : dataValue;
    } else {
      return t("NA");
    }
  };

  const actionObject = workflowDetails?.data?.processInstances?.[0]?.auditDetails;
  const currentTime = new Date().getTime();
  const hoursDifference = (currentTime - actionObject?.createdTime) / (1000 * 60 * 60);
  const twentyFourHoursPassed = hoursDifference >= 24;

  async function getRecieptSearch({ tenantId, payments, ...params }) {
    let response = { filestoreIds: [payments?.fileStoreId] };
    response = await Digit.PaymentService.generatePdf(tenantId, { Payments: [{ ...payments }] }, "consolidatedreceipt");
    const fileStore = await Digit.PaymentService.printReciept(tenantId, { fileStoreIds: response.filestoreIds[0] });
    window.open(fileStore[response?.filestoreIds[0]], "_blank");
  }

  async function getPermitOccupancyOrderSearch({ tenantId }, order, mode = "download") {
    let currentDate = new Date();
    data.applicationData.additionalDetails.runDate = convertDateToEpoch(
      currentDate.getFullYear() + "-" + (currentDate.getMonth() + 1) + "-" + currentDate.getDate()
    );
    let requestData = { ...data?.applicationData, edcrDetail: [{ ...data?.edcrDetails }] };
    let response = await Digit.PaymentService.generatePdf(tenantId, { Bpa: [requestData] }, order);
    const fileStore = await Digit.PaymentService.printReciept(tenantId, { fileStoreIds: response.filestoreIds[0] });
    window.open(fileStore[response?.filestoreIds[0]], "_blank");
    requestData["applicationType"] = data?.applicationData?.additionalDetails?.applicationType;
    let edcrResponse = await Digit.OBPSService.edcr_report_download({ BPA: { ...requestData } });
    const responseStatus = parseInt(edcrResponse.status, 10);
    if (responseStatus === 201 || responseStatus === 200) {
      mode == "print"
        ? printPdf(new Blob([edcrResponse.data], { type: "application/pdf" }))
        : downloadPdf(new Blob([edcrResponse.data], { type: "application/pdf" }), `edcrReport.pdf`);
    }
  }

  async function getApprovalLetter() {
    const res = await OBPSService.designOfApprovalLetterPdf(tenantId, data?.applicationData?.applicationNo);
    const pdfBlob = new Blob([res?.data], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  }
  async function getEmployeeStructuralLetter(url) {
    window.open(url, "_blank");
  }
  function getEmployeeApprovalLetter(url) {
    window.open(url, "_blank");
  }

  async function getRevocationPDFSearch({ tenantId, ...params }) {
    let requestData = { ...data?.applicationData };
    let response = await Digit.PaymentService.generatePdf(tenantId, { Bpa: [requestData] }, "bpa-revocation");
    const fileStore = await Digit.PaymentService.printReciept(tenantId, { fileStoreIds: response.filestoreIds[0] });
    window.open(fileStore[response?.filestoreIds[0]], "_blank");
  }

  useEffect(() => {
    const workflow = { action: selectedAction };
    switch (selectedAction) {
      case "APPROVE":
      case "SEND_TO_ARCHITECT":
      case "APPLY":
      case "SKIP_PAYMENT":
      case "SEND_TO_JE":
      case "UPLOAD_SITE_INSPECTION_REPORT":
      case "REJECT":
      case "SENDBACK_TO_ARCHITECT":
      case "FRWD_TO_JE":
      case "ASSIGN_TO_STRUCTURE_ENGINEER":
      case "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE":
        setShowModal(true);
    }
  }, [selectedAction]);

  const closeToast = () => {
    setShowToast(null);
  };

  const downloadDiagram = (val) => {
    location.href = val;
  };

  const handleChange = () => {};

  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };

  const closeTermsModal = () => {
    setShowTermsModal(false);
  };

  async function onActionSelect(action) {
    let path = data?.applicationData?.businessService == "BPA_OC" ? "ocbpa" : "bpa";
    const allPossibleActions = ["SEND_TO_JA", "SEND_TO_CLERK", "SEND_TO_JDM_JE_SPD"];
    const selectedAction = allPossibleActions.filter((e) => e === action).toString();
    if (action === "FORWARD") {
      history.replace(
        `/digit-ui/citizen/obps/sendbacktocitizen/ocbpa/${data?.applicationData?.tenantId}/${data?.applicationData?.applicationNo}/check`,
        { data: data?.applicationData, edcrDetails: data?.edcrDetails }
      );
    }
    if (action === "MAKE_PAYMENT") {
      let applicationType = data?.applicationData?.applicationType;
      let payload = {};
      if (applicationType === "FORM_12") {
        payload.BPA = data?.applicationData;
        payload.BPA.workflow = {
          action: "MAKE_PAYMENT",
          assignes: null,
          comments: null,
          varificationDocuments: null,
        };
        payload.RequestInfo = data?.applicationData?.RequestInfo;
        try {
          const response = await OBPSService.update(payload, tenantId);
          window.location.assign(
            `${
              window.location.origin
            }/digit-ui/citizen/payment/collect/${`bpa/${id}/${data?.tenantId}?tenantId=${data?.tenantId}?flow=${applicationType}`}`
          );
        } catch (error) {
          console.error("Error in MAKE_PAYMENT action:", error);
        }
      } else if (applicationType === "FORM_11") {
        payload.PermissionOfSubdivision = data?.applicationData;
        payload.PermissionOfSubdivision.workflow = {
          action: "MAKE_PAYMENT",
          assignes: null,
          comments: null,
          varificationDocuments: null,
        };
        payload.RequestInfo = data?.applicationData?.RequestInfo;
        try {
          const response = await OBPSService.updateForm11(payload, tenantId);
          window.location.assign(
            `${
              window.location.origin
            }/digit-ui/citizen/payment/collect/${`bpa/${id}/${data?.tenantId}?tenantId=${data?.tenantId}?flow=${applicationType}`}`
          );
        } catch (error) {
          console.error("Error in MAKE_PAYMENT action:", error);
        }
      }
      //update call
    }
    if (action === "APPROVAL_LETTER_GENERATE") {
      let payload = {};
      payload.BPA = data?.applicationData;
      (payload.BPA.workflow = {
        action: "APPROVAL_LETTER_GENERATE",
        assignes: null,
        comments: null,
        varificationDocuments: null,
      }),
        (payload.RequestInfo = data?.applicationData?.RequestInfo);
      //update call
      try {
        const res = await OBPSService.designOfApprovalLetterPdf(tenantId, data?.applicationData?.applicationNo);
        const pdfBlob = new Blob([res?.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);
        if (res) {
          const response = await OBPSService.update(payload, tenantId);
          if (response) {
            history.replace(`/digit-ui/citizen/obps/response`, { data: payload });
          }
        } else {
          setShowToast({ key: "error", error: { message: "Error in APPROVAL_LETTER_GENERATE" } });
        }
      } catch (error) {
        console.error("Error in approval letter generate action:", error);
      }
    }
    if (action === "GENERATE_STRUCTURAL_STABILITY_CERTIFICATE") {
      let payload = {};
      payload.BPA = data?.applicationData;
      (payload.BPA.workflow = {
        action: "GENERATE_STRUCTURAL_STABILITY_CERTIFICATE",
        assignes: null,
        comments: null,
        varificationDocuments: null,
      }),
        (payload.RequestInfo = data?.applicationData?.RequestInfo);
      //update call
      try {
        const res = await OBPSService.designOfStructuralLetter(tenantId, data?.applicationData?.applicationNo);
        const pdfBlob = new Blob([res?.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);
        if (res) {
          const response = await OBPSService.update(payload, tenantId);
          if (response) {
            history.replace(`/digit-ui/citizen/obps/response`, { data: payload });
          }
        } else {
          setShowToast({ key: "error", error: { message: "Error in STRUCTURAL_LETTER_GENERATE" } });
        }
      } catch (error) {
        console.error("Error in approval letter generate action:", error);
      }
    }
    if (action?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE") {
      setShowModal(false);
      let payload = {};
      payload.BPA = applicationData;
      (payload.BPA.workflow = {
        action: "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE",
        assignes: null,
        comments: onAddComments,
        varificationDocuments: null,
      }),
        (payload.RequestInfo = applicationDetails?.RequestInfo);
      //update call
      try {
        const res = await OBPSService.designOfApprovalLetterPdf(state, applicationDetails?.applicationNo);
        const pdfBlob = new Blob([res?.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);
      } catch (error) {
        console.error("Error in APPROVAL_LETTER_GENERATE action:", error);
      }
    }

    if (action === "SEND_TO_CITIZEN") {
      if (workflowDetails?.data?.processInstances?.length > 2) {
        window.location.replace(
          `/digit-ui/citizen/obps/editApplication/${path}/${data?.applicationData?.tenantId}/${data?.applicationData?.applicationNo}`
        );
      } else {
        getBPAFormData(data?.applicationData, mdmsData, history, t);
      }
    }
    if (action === selectedAction) {
      const workflow = { action: selectedAction };
      mutation.mutate(
        { BPA: { ...data?.applicationData, workflow } },
        {
          onError: (error, variables) => {
            setIsEnableLoader(false);
            setShowModal(false);
            setShowToast({ key: "error", action: error?.response?.data?.Errors[0]?.message ? error?.response?.data?.Errors[0]?.message : error });
            setTimeout(closeToast, 5000);
          },
          onSuccess: (data, variables) => {
            setIsEnableLoader(false);
            history.replace(`/digit-ui/citizen/obps/response`, { data: data });
            setShowModal(false);
            setShowToast({ key: "success", action: selectedAction });
            setTimeout(closeToast, 5000);
            queryClient.invalidateQueries("BPA_DETAILS_PAGE");
            queryClient.invalidateQueries("workFlowDetails");
          },
        }
      );
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }

  function checkForSubmitDisable() {
    if (checkBoxVisible) return isFromSendBack ? !isFromSendBack : !isTocAccepted;
    else return false;
  }

  const submitAction = (workflow) => {
    setIsEnableLoader(true);
    mutation.mutate(
      { BPA: { ...data?.applicationData, workflow } },
      {
        onError: (error, variables) => {
          setIsEnableLoader(false);
          setShowModal(false);
          setShowToast({ key: "error", action: error?.response?.data?.Errors[0]?.message ? error?.response?.data?.Errors[0]?.message : error });
          setTimeout(closeToast, 5000);
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(false);
          history.replace(`/digit-ui/citizen/obps/response`, { data: data });
          setShowModal(false);
          setShowToast({ key: "success", action: selectedAction });
          setTimeout(closeToast, 5000);
          queryClient.invalidateQueries("BPA_DETAILS_PAGE");
          queryClient.invalidateQueries("workFlowDetails");
        },
      }
    );
  };

  if (workflowDetails?.data?.nextActions?.length > 0 && data?.applicationData?.status == "CITIZEN_APPROVAL_INPROCESS") {
    const userInfo = Digit.UserService.getUser();
    const rolearray = userInfo?.info?.roles;
    if (data?.applicationData?.status == "CITIZEN_APPROVAL_INPROCESS") {
      if (rolearray?.length == 1 && rolearray?.[0]?.code == "CITIZEN") {
        workflowDetails.data.nextActions = workflowDetails?.data?.nextActions;
      } else {
        workflowDetails.data.nextActions = [];
      }
    } else if (data?.applicationData?.status == "INPROGRESS") {
      let isArchitect = false;
      stakeHolderDetails?.StakeholderRegistraition?.TradeTypetoRoleMapping?.map((type) => {
        type?.role?.map((role) => {
          roles.push(role);
        });
      });
      const uniqueRoles = roles.filter((item, i, ar) => ar.indexOf(item) === i);
      if (rolearray?.length > 1) {
        rolearray.forEach((role) => {
          if (uniqueRoles.includes(role.code)) {
            isArchitect = true;
          }
        });
      }
      if (isArchitect) {
        workflowDetails.data.nextActions = workflowDetails?.data?.nextActions;
      } else {
        workflowDetails.data.nextActions = [];
      }
    }
  }

  if (workflowDetails?.data?.processInstances?.[0]?.action === "SEND_BACK_TO_CITIZEN") {
    if (isTocAccepted) setIsTocAccepted(true);
    isFromSendBack = true;
    const userInfo = Digit.UserService.getUser();
    const rolearray = userInfo?.info?.roles;
    if (rolearray?.length !== 1) {
      workflowDetails = {
        ...workflowDetails,
        data: {
          ...workflowDetails?.data,
          actionState: {
            nextActions: [],
          },
        },
        data: {
          ...workflowDetails?.data,
          nextActions: [],
        },
      };
    }
  }

  if (isLoading || isEnableLoader) {
    return <Loader />;
  }

  let dowloadOptions = [];
  if (data?.collectionBillDetails?.length > 0) {
    const bpaPayments = cloneDeep(data?.collectionBillDetails);
    bpaPayments.forEach((pay) => {
      if (pay?.paymentDetails[0]?.businessService === "BPA.NC_OC_APP_FEE") {
        dowloadOptions.push({
          order: 1,
          label: t("BPA_APP_FEE_RECEIPT"),
          onClick: () =>
            getRecieptSearch({ tenantId: data?.applicationData?.tenantId, payments: pay, consumerCodes: data?.applicationData?.applicationNo }),
        });
      }

      if (pay?.paymentDetails[0]?.businessService === "BPA.NC_OC_SAN_FEE") {
        dowloadOptions.push({
          order: 2,
          label: t("BPA_OC_DEV_PEN_RECEIPT"),
          onClick: () =>
            getRecieptSearch({ tenantId: data?.applicationData?.tenantId, payments: pay, consumerCodes: data?.applicationData?.applicationNo }),
        });
      }

      if (pay?.paymentDetails[0]?.businessService === "BPA.LOW_RISK_PERMIT_FEE") {
        dowloadOptions.push({
          order: 1,
          label: t("BPA_FEE_RECEIPT"),
          onClick: () =>
            getRecieptSearch({ tenantId: data?.applicationData?.tenantId, payments: pay, consumerCodes: data?.applicationData?.applicationNo }),
        });
      }

      if (pay?.paymentDetails[0]?.businessService === "BPA.NC_APP_FEE") {
        dowloadOptions.push({
          order: 1,
          label: t("BPA_APP_FEE_RECEIPT"),
          onClick: () =>
            getRecieptSearch({ tenantId: data?.applicationData?.tenantId, payments: pay, consumerCodes: data?.applicationData?.applicationNo }),
        });
      }

      if (pay?.paymentDetails[0]?.businessService === "BPA.NC_SAN_FEE") {
        dowloadOptions.push({
          order: 2,
          label: t("BPA_SAN_FEE_RECEIPT"),
          onClick: () =>
            getRecieptSearch({ tenantId: data?.applicationData?.tenantId, payments: pay, consumerCodes: data?.applicationData?.applicationNo }),
        });
      }
    });
  }

  if (data && data?.applicationData?.businessService === "BPA_LOW" && data?.collectionBillDetails?.length > 0) {
    !data?.applicationData?.status.includes("REVOCATION") &&
      dowloadOptions.push({
        order: 3,
        label: t("BPA_PERMIT_ORDER"),
        onClick: () => getPermitOccupancyOrderSearch({ tenantId: data?.applicationData?.tenantId }, "buildingpermit-low"),
      });
    data?.applicationData?.status.includes("REVOCATION") &&
      dowloadOptions.push({
        order: 3,
        label: t("BPA_REVOCATION_PDF_LABEL"),
        onClick: () => getRevocationPDFSearch({ tenantId: data?.applicationData?.tenantId }),
      });
  } else if (data && data?.applicationData?.businessService === "BPA" && data?.collectionBillDetails?.length > 0) {
    if (data?.applicationData?.status === "APPROVED") {
      dowloadOptions.push({
        order: 3,
        label: t("BPA_PERMIT_ORDER"),
        onClick: () => getPermitOccupancyOrderSearch({ tenantId: data?.applicationData?.tenantId }, "buildingpermit"),
      });
    }
  } else {
    // if(data?.applicationData?.status==="APPROVED"){
    //   dowloadOptions.push({
    //     order: 3,
    //     label: t("BPA_OC_CERTIFICATE"),
    //     onClick: () => getPermitOccupancyOrderSearch({tenantId: data?.applicationData?.tenantId},"occupancy-certificate"),
    //   });
    // }
    if (
      data?.applicationData?.plotArea < 500 &&
      (data?.applicationData?.status === "APPROVED" || data?.applicationData?.status === "UPLOAD_SITE_INSPECTION")
    ) {
      dowloadOptions.push({
        order: 1,
        label: t("BPA_DOWNLOAD_APPROVAL_LETTER"),
        onClick: () => getApprovalLetter(),
      });
    }
    const filteredArray = workflowDetails?.data?.timeline?.filter((item) => item.performedAction === "UPLOAD_DIGI_SIGN_LETTER");
    if (data?.applicationData?.status === "APPROVED" && filteredArray?.length > 0 && filteredArray?.[0]?.thumbnailsToShow?.fullImage?.length > 0) {
      const url = filteredArray?.[0]?.thumbnailsToShow?.fullImage?.[0];
      dowloadOptions.push({
        order: 2,
        label: t("BPA_DOWNLOAD_APPROVAL_LETTER"),
        onClick: () => getEmployeeApprovalLetter(url),
      });
    }
    if (workflowDetails?.data?.timeline?.length > 3) {
      const filteredArray = workflowDetails?.data?.timeline?.filter((item) => item.status === "SEND_TO_ARCHITECT");
      const url = filteredArray?.[0]?.thumbnailsToShow?.fullImage?.[0];
      dowloadOptions.push({
        order: 3,
        label: t("BPA_DOWNLOAD_STRUCTURAL_LETTER"),
        onClick: () => getEmployeeStructuralLetter(url),
      });
    }
  }

  if (data?.comparisionReport) {
    dowloadOptions.push({
      order: 4,
      label: t("BPA_COMPARISON_REPORT_LABEL"),
      onClick: () => window.open(data?.comparisionReport?.comparisonReport, "_blank"),
    });
  }

  dowloadOptions.sort(function (a, b) {
    return a.order - b.order;
  });

  if (workflowDetails?.data?.nextActions?.length > 0) {
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter((actn) => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter((actn) => actn.action !== "ADHOC");
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter((actn) => actn.action !== "SKIP_PAYMENT");
  }

  if (data?.applicationDetails?.length > 0) {
    data.applicationDetails =
      data?.applicationDetails?.length > 0 && data?.applicationDetails?.filter((bpaData) => Object.keys(bpaData).length !== 0);
  }

  const getCheckBoxLable = () => {
    return (
      <div>
        <span>{`${t("BPA_I_AGREE_THE_LABEL")} `}</span>
        <span style={{ color: "#1F4A7C", cursor: "pointer" }} onClick={() => setShowTermsModal(!showTermsModal)}>
          {t(`BPA_TERMS_AND_CONDITIONS_LABEL`)}
        </span>
      </div>
    );
  };

  const results = data?.applicationDetails?.filter((element) => {
    if (Object.keys(element).length !== 0) {
      return true;
    }
    return false;
  });

  if (results?.length > 0) {
    data.applicationDetails = results;
  }
  // new

  const handleshow19 = async (e) => {
    // setLoader(true);
    console.log("enter111111111");
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        ver: ".01",
        ts: null,
        action: "_update",
        did: "1",
        key: "",
        msgId: "20170310130900|en_IN",
        authToken: authToken,
        userInfo: userInfo,
      },
    };

    try {
      console.log("5555676877try");
      const Resp = await axios.post(`${Urls.obps.designOfStuctural}?tenantId=hp&applicationNumber=${id}`, payload, { responseType: "arraybuffer" });
      //   setLoader(false);
      const pdfBlob = new Blob([Resp.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl);
      setShowTakeAction("Take_Action");
    } catch (error) {
      //   setLoader(false);
      console.log("5555676877catch");
      return error;
    }
  };
  const handleChangedata = (e) => {
    // setLoader(false);
    this.setState({ isRadioSelected: true });
  };

  return (
    <Fragment>
      <Card>
        <Tabs value={currentTab} onChange={handleChangeTab}>
          {tablist.map(({ label, color }, index) => (
            <Tab label={`${t(label)}`} value={`${index}`} sx={{ textTransform: "none", p: "0 1rem", color }} />
          ))}
        </Tabs>
        <TabPanel value={currentTab} index="0" sx={{ p: 0 }}>
          {/* {data?.applicationData?.status === "UPLOAD_SITE_INSPECTION" && <NewsTicker textForNews={textForNews}/>}
      {data?.applicationData?.status === "SEND_TO_STRUCTURE_ENGINEER" && (signValid === null) && <NewsTicker textForNews={signValidity}/>}
      {data?.applicationData?.status === "APPROVAL_LETTER_GENERATE" && (signValid === null) && <NewsTicker textForNews={signforApprovalLetter}/>}
      <div className="cardHeaderWithOptions" style={{ maxWidth: "960px" }}>
        <Header styles={{fontSize: "32px"}}>{t("CS_TITLE_APPLICATION_DETAILS")}</Header>
        {dowloadOptions && dowloadOptions.length > 0 && <MultiLink
          className="multilinkWrapper"
          onHeadClick={() => setShowOptions(!showOptions)}
          displayOptions={showOptions}
          options={dowloadOptions}

        />}
      </div> */}
          <div>
            {data?.applicationData?.applicationType === "FORM_12" && (
              //  <Card style={{marginRight:"0%",marginLeft:"15%"}}>
              <ApplicationView12 id={id} formType={data?.applicationData?.applicationType} />
              //  </Card>
            )}

            {data?.applicationDetails
              ?.filter((ob) => Object.keys(ob).length > 0)
              .map((detail, index, arr) => {
                return (
                  <div>
                    {/* {!detail?.isNotAllowed ? <Card key={index} style={!detail?.additionalDetails?.fiReport && detail?.title === "" ? { marginTop: "-30px" } : {}}>

      {!detail?.isTitleVisible ? <CardSubHeader style={{fontSize: "24px"}}>{t(detail?.title)}</CardSubHeader> : null}
      
      <div style={detail?.isBackGroundColor ? { marginTop: "19px", background: "#FAFAFA", border: "1px solid #D6D5D4", borderRadius: "4px", padding: "8px", lineHeight: "19px", maxWidth: "950px", minWidth: "280px" } : {}}>
</div>
    </Card> : null } */}
                    {/* to get Timeline values */}
                    {index === arr.length - 1 && (
                      <Card>
                        <Fragment>
                          {/* <BPAApplicationTimeline application={data?.applicationData} id={id} /> */}
                          {!workflowDetails?.isLoading && workflowDetails?.data?.nextActions?.length > 0 && !isFromSendBack && checkBoxVisible && (
                            <CheckBox
                              styles={{ margin: "20px 0 40px", paddingTop: "10px" }}
                              checked={isTocAccepted}
                              label={getCheckBoxLable()}
                              // label={getCheckBoxLabelData(t, data?.applicationData, workflowDetails?.data?.nextActions)}
                              onChange={() => {
                                setIsTocAccepted(!isTocAccepted);
                                isTocAccepted ? setDisplayMenu(!isTocAccepted) : "";
                              }}
                            />
                          )}
                          {!workflowDetails?.isLoading &&
                            workflowDetails?.data?.nextActions?.length > 1 &&
                            workflowDetails?.data?.nextActions?.[0]?.action != "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && (
                              <ActionBar style={{ position: "relative", boxShadow: "none", minWidth: "240px", maxWidth: "310px", padding: "0px" }}>
                                <div style={{ width: "100%" }}>
                                  {displayMenu && workflowDetails?.data?.nextActions ? (
                                    <Menu
                                      style={{ bottom: "37px", minWidth: "240px", maxWidth: "310px", width: "100%", right: "0px" }}
                                      localeKeyPrefix={"WF_BPA"}
                                      options={workflowDetails?.data?.nextActions.map((action) => action.action)}
                                      //options={plotArea === "MAXPLOT" ? workflowDetails?.data?.nextActions.slice(1).map((action) => action.action) : workflowDetails?.data?.nextActions.slice(0, 1).map((action) => action.action)}
                                      t={t}
                                      onSelect={onActionSelect}
                                    />
                                  ) : null}
                                  <SubmitBar
                                    style={{ width: "100%" }}
                                    disabled={checkForSubmitDisable(isFromSendBack, isTocAccepted)}
                                    label={t("ES_COMMON_TAKE_ACTION")}
                                    onSubmit={() => setDisplayMenu(!displayMenu)}
                                  />
                                </div>
                              </ActionBar>
                            )}
                          {!workflowDetails?.isLoading &&
                            (workflowDetails?.data?.nextActions?.length > 1 ||
                              workflowDetails?.data?.nextActions?.[0]?.action === "UPLOAD_SITE_INSPECTION_REPORT") &&
                            isStakeholder &&
                            twentyFourHoursPassed && (
                              <ActionBar style={{ position: "relative", boxShadow: "none", minWidth: "240px", maxWidth: "310px", padding: "0px" }}>
                                <div style={{ width: "100%" }}>
                                  {displayMenu && workflowDetails?.data?.nextActions ? (
                                    <Menu
                                      style={{ bottom: "37px", minWidth: "240px", maxWidth: "310px", width: "100%", right: "0px" }}
                                      localeKeyPrefix={"WF_BPA"}
                                      options={workflowDetails?.data?.nextActions.map((action) => action.action)}
                                      t={t}
                                      onSelect={onActionSelect}
                                    />
                                  ) : null}
                                  <SubmitBar
                                    style={{ width: "100%" }}
                                    disabled={checkForSubmitDisable(isFromSendBack, isTocAccepted)}
                                    label={t("ES_COMMON_TAKE_ACTION")}
                                    onSubmit={() => setDisplayMenu(!displayMenu)}
                                  />
                                </div>
                              </ActionBar>
                            )}
                          {!workflowDetails?.isLoading &&
                            workflowDetails?.data?.nextActions?.length > 1 &&
                            workflowDetails?.data?.nextActions?.[0]?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && (
                              <Card style={{ marginRight: "0%", marginLeft: "15%" }}>
                                <div style={{ display: "flex" }}>
                                  <div className="px-3">
                                    <Button
                                      style={{ textAlign: "right", padding: "4px" }}
                                      value="Submit"
                                      id="Submit"
                                      onChange1={handleChangedata}
                                      name="Submit"
                                      onClick={handleshow19}
                                    >
                                      Issue Structural Certificate PDF <FileDownloadIcon />
                                    </Button>
                                  </div>
                                  {showTakeAction === "Take_Action" && (
                                    <ActionBar
                                      style={{ position: "relative", boxShadow: "none", minWidth: "240px", maxWidth: "310px", padding: "0px" }}
                                    >
                                      <div style={{ width: "100%" }}>
                                        {displayMenu && workflowDetails?.data?.nextActions ? (
                                          <Menu
                                            style={{ bottom: "37px", minWidth: "240px", maxWidth: "310px", width: "100%", right: "0px" }}
                                            localeKeyPrefix={"WF_BPA"}
                                            options={workflowDetails?.data?.nextActions.map((action) => action.action)}
                                            t={t}
                                            onSelect={onActionSelect}
                                          />
                                        ) : null}
                                        <SubmitBar
                                          style={{ width: "100%" }}
                                          disabled={checkForSubmitDisable(isFromSendBack, isTocAccepted)}
                                          label={t("ES_COMMON_TAKE_ACTION")}
                                          onSubmit={() => setDisplayMenu(!displayMenu)}
                                        />
                                      </div>
                                    </ActionBar>
                                  )}
                                </div>
                              </Card>
                            )}

                          {!workflowDetails?.isLoading &&
                            workflowDetails?.data?.nextActions?.length == 1 &&
                            workflowDetails?.data?.nextActions?.[0]?.action !== "UPLOAD_SITE_INSPECTION_REPORT" && (
                              <ActionBar style={{ position: "relative", boxShadow: "none", minWidth: "240px", maxWidth: "310px", padding: "0px" }}>
                                <div style={{ width: "100%" }}>
                                  <button
                                    style={{ width: "100%", color: "#FFFFFF", fontSize: "19px" }}
                                    className={`${checkForSubmitDisable(isFromSendBack, isTocAccepted) ? "submit-bar-disabled" : "submit-bar"}`}
                                    disabled={checkForSubmitDisable(isFromSendBack, isTocAccepted)}
                                    name={workflowDetails?.data?.nextActions?.[0]?.action}
                                    value={workflowDetails?.data?.nextActions?.[0]?.action}
                                    onClick={(e) => {
                                      onActionSelect(e.target.value);
                                    }}
                                  >
                                    {t(`WF_BPA_${workflowDetails?.data?.nextActions?.[0]?.action}`)}
                                  </button>
                                </div>
                              </ActionBar>
                            )}
                        </Fragment>
                      </Card>
                    )}
                  </div>
                );
              })}
          </div>
        </TabPanel>
        <TabPanel value={currentTab} index="1" sx={{ p: 0 }}>
          {data?.applicationDetails
            ?.filter((ob) => Object.keys(ob).length > 0)
            .map((detail, index, arr) => {
              return (
                <div>
                  {index === arr.length - 1 && (
                    <Fragment>
                      <BPAApplicationTimeline application={data?.applicationData} id={id} />
                    </Fragment>
                  )}
                </div>
              );
            })}
        </TabPanel>
      </Card>
      {showTermsModal ? (
        <ActionModal
          t={t}
          action={"TERMS_AND_CONDITIONS"}
          tenantId={tenantId}
          id={id}
          closeModal={closeTermsModal}
          submitAction={submitAction}
          applicationData={data?.applicationData || {}}
        />
      ) : null}
      {showModal ? (
        <ActionModal
          t={t}
          action={selectedAction}
          tenantId={tenantId}
          // state={state}
          id={id}
          closeModal={closeModal}
          submitAction={submitAction}
          actionData={workflowDetails?.data?.timeline}
          applicationData={data?.applicationData || {}}
        />
      ) : null}
      {showToast && (
        <Toast
          error={showToast.key === "error" ? true : false}
          label={t(showToast.key === "success" ? `ES_OBPS_${showToast.action}_UPDATE_SUCCESS` : showToast.action)}
          onClose={closeToast}
          style={{ zIndex: "1000" }}
        />
      )}
    </Fragment>
  );
};

export default BpaApplicationDetail;
